import { html } from 'lit';

export default function assistantLogo(isWithColors: boolean) {
  return html`
    <div class="animated-logo ${isWithColors ? '' : 'animated-logo_gray'}">
      <div class="animated-logo__section animated-logo__section-1"></div>
      <div class="animated-logo__section animated-logo__section-2"></div>
      <div class="animated-logo__section animated-logo__section-3"></div>
      <div class="animated-logo__section animated-logo__section-4"></div>
    </div>
  `;
}
